import axios from 'axios';
import {toast} from "react-toastify";
import {AlertMessage} from "../utils/alert-message";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const API_URL = process.env.REACT_APP_API_URL;
const MySwal = withReactContent(Swal);


const SshService = {
    openSshConnection: (projectId, sshId) => {
        axios.get(API_URL + `/dashboard/ssh/url/${projectId}/${sshId}`)
            .then(({data: {data}}) => {
                const sshUrl = data?.url ?? data;
                const ssh_warning = data?.ssh_warning;
                const windowName = `${projectId}-ibge`;

                if (ssh_warning){
                    MySwal.fire({
                        icon: "warning",
                        title: "Aviso!",
                        text: ssh_warning,
                        didOpen: () => {
                            const htmlContainer = Swal.getHtmlContainer();
                            if (htmlContainer) {
                                htmlContainer.style.whiteSpace = "pre-line";
                            }
                        },
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#1D4ED8",
                    }).then(({ isConfirmed }) => {
                        if (isConfirmed) {
                            window.open(sshUrl, windowName);
                        }
                    });
                }else{
                    window.open(sshUrl, windowName);
                }

            })
            .catch(error => {
                const {data: {message}} = error.response;
                toast.error(AlertMessage[message] ?? "Não foi possível prosseguir");
            });
    }
};

export default SshService;
